
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Donation Details - Get All (Read)
export const GetAll = createAsyncThunk(
  "/admin/volunteer-details",
  async (filter = {}, { rejectWithValue }) => {
    try {
      const { volunteering_id, search, page, per_page } = filter;

      // Build query string
      let query = `?`;
      if (volunteering_id) query += `volunteering_id=${volunteering_id}&`;
      if (search) query += `name=${search}&`;
      if (page) query += `page=${page}&`;
      if (per_page) query += `per_page=${per_page}&`;

      // Remove trailing &
      query = query.slice(0, -1);

      const res = await GET(`${APIS.Volunteers.volunteer}${query}`);

      // console.log("Donation Details Response:", res);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "volunteer_details",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;


















